Core.RoutesRouter = Core.SubRouter.extend({
    routes: {
        '': 'routeList',

        'new': 'newRoute',
        'continue': 'continueRoute',
        ':id': 'viewRoute',
        ':id/edit': 'editRoute',

        'mine': 'mine',
        'all': 'all',
        'unassigned': 'unassigned',
        'templates': 'templates',
        'today': 'today',
        'user/:id': 'user'
    },

    routeList: function () {
        debug.log('routes');
        var view = new RouteListView({ scrolling: true });
        var hash = Core.param('hash');
        console.log(hash);
        if (hash) {
            this.navigate(hash, { trigger: true, replace: true });
        } else {
            view.fetchList('all');
        }
        app.setMainView(view, 'routes', { wideContainer: true});
    },

    newRoute: function () {
        debug.log('new route');
        var view = new RouteDetailView({model: new Route(), editing: true});
        if (Core.param('returnto')) view.saveAction = Core.param('returnto');
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'routes');
    },

    continueRoute: function () {
        debug.log('continue route', sessionStorage.routeplanner_addJobs);
        if ('routeplanner_continue' in sessionStorage) {
            var view = new RouteDetailView({model: new Route(), editing: true});
            if (Core.param('returnto')) view.saveAction = Core.param('returnto');
            var route = JSON.parse(sessionStorage['routeplanner_continue']);
            console.log('continue', route);
            view.model.set(route)
            view.model.loaded = true;
            app.setMainView(view, 'routes');
            sessionStorage.removeItem('routeplanner_continue');
            app.setMainView(view, 'routes');
        } else {
            this.newRoute();
        }
    },

    viewRoute: function (id) {
        debug.log('view route', id);
        var view = new RouteDetailView({model: new Route({id: id}), editing: false});
        if (Core.param('returnto')) view.saveAction = Core.param('returnto');
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'routes');
    },

    editRoute: function (id) {
        debug.log('edit route', id);
        var view = new RouteDetailView({model: new Route({id: id}), editing: true});
        if (Core.param('returnto')) view.saveAction = Core.param('returnto');
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'routes');
    },

    mine: function () {
        debug.log('mine');
        var view = new RouteListView({scrolling: true});
        view.selectList('mine');
        app.setMainView(view, 'routes', { wideContainer: true});
    },

    all: function () {
        debug.log('all');
        var view = new RouteListView({scrolling: true});
        view.selectList('all');
        app.setMainView(view, 'routes', { wideContainer: true});
    },

    unassigned: function () {
        debug.log('unassigned');
        var view = new RouteListView({scrolling: true});
        view.selectList('unassigned');
        app.setMainView(view, 'routes', { wideContainer: true});
    },

    templates: function () {
        debug.log('templates');
        var view = new RouteListView({scrolling: true});
        view.fetchList('templates');
        app.setMainView(view, 'routes', { wideContainer: true});
    },

    today: function () {
        debug.log('today');
        var view = new RouteListView({scrolling: true});
        view.selectList('today');
        app.setMainView(view, 'routes', { wideContainer: true});
    },

    user: function (id) {
        debug.log('user', id);
        var view = new RouteListView({scrolling: true});
        view.selectList('user-'+id);
        app.setMainView(view, 'routes', { wideContainer: true});
    }

});
